import React from 'react';
import { AlertTriangleIcon, ExternalLinkIcon, InfoIcon } from 'lucide-react';
import { CALENDLY_URL } from '../../data/roadmapContent';
import { LMI_NOTE, LOWER_DEPOSIT_NOTE } from '../../data/stampDuty';
import { formatCurrency } from '../../utils/roadmapCalcs';
import { minimumDeposit } from '../../utils/stampDuty';
interface MinimumDepositNoteProps {
  propertyPrice: number;
  deposit: number;
  isInvestment: boolean;
}

/**
 * Reference point beneath the deposit field, derived from the property price
 * already given — nothing extra is asked. This informs, it does not gate:
 * entering less than the minimum is always allowed.
 */
export function MinimumDepositNote({
  propertyPrice,
  deposit,
  isInvestment
}: MinimumDepositNoteProps) {
  const minimum = minimumDeposit(propertyPrice, isInvestment);
  if (minimum <= 0) return null;
  const percent = isInvestment ? '10%' : '5%';
  const short = deposit > 0 && deposit < minimum;
  return <div className="mt-5 space-y-4" data-id="element-206" data-mp="22kw4eebpzqp2">
      <p className={`flex items-start gap-2.5 text-sm leading-relaxed ${short ? 'text-amber-700 dark:text-amber-300' : 'text-slate-600 dark:text-slate-400'}`} data-id="element-207" data-mp="5ew35lsg0iwp">
        {short ? <AlertTriangleIcon className="w-4 h-4 flex-shrink-0 mt-0.5" data-id="element-208" data-mp="int2mt3rfwe" /> : <InfoIcon className="w-4 h-4 flex-shrink-0 mt-0.5 text-primary-500" data-id="element-209" data-mp="egvkkf7ddp06" />}
        {short ? <span data-id="element-210" data-mp="adfphnay7wpl">
            That's {formatCurrency(minimum - deposit)} under the{' '}
            {formatCurrency(minimum)} most lenders look for on a{' '}
            {formatCurrency(propertyPrice)} purchase. You can keep going — it's
            worth knowing, not a dead end.
          </span> : <span data-id="element-211" data-mp="y4cu0f0ezrqt">
            Most lenders look for at least{' '}
            <span className="font-semibold text-slate-900 dark:text-white" data-id="element-212" data-mp="t505lptwacm4">
              {formatCurrency(minimum)}
            </span>{' '}
            ({percent}) on a {formatCurrency(propertyPrice)}{' '}
            {isInvestment ? 'investment' : 'purchase'}. It varies by lender,
            property type and location.
          </span>}
      </p>

      <div className="rounded-2xl border border-slate-200 dark:border-white/10 bg-white dark:bg-white/5 p-5" data-id="element-213" data-mp="3vyxyp3lzutbm">
        <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed" data-id="element-214" data-mp="4rv6q9yc0j0c">
          {LOWER_DEPOSIT_NOTE}
        </p>
        
        <a href={CALENDLY_URL} target="_blank" rel="noopener noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 transition-colors" data-id="element-215" data-mp="8r43lnoo4x04">
          Book a Call With Liam
          <ExternalLinkIcon className="w-3.5 h-3.5" data-id="element-216" data-mp="njxrnxi0alge" />
        </a>
      </div>
    </div>;
}